import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useRuntimeConfig,
} from '#imports';
import type { RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '~/stores/auth';

function authProfileUrl(authLink: unknown): string | null {
  if (!authLink || typeof authLink !== 'string') {
    return null;
  }
  const base = authLink.replace(/\/$/, '');
  return `${base}/profile`;
}

/** Проверка meta.requiredPermission; без права — редирект на auth-front /profile. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  const permission = to.meta.requiredPermission;
  if (!permission) {
    return;
  }
  const authStore = useAuthStore();
  if (!authStore.hasUserPermission(permission as string)) {
    const profileUrl = authProfileUrl(useRuntimeConfig().public.authLink);
    if (profileUrl) {
      return navigateTo(profileUrl, { external: true });
    }
    return navigateTo('/owners');
  }
});
